export const appointmentMeetingKindOptions = [
    {label: 'reports.meetingKind.telephone', value: 'Telephone meeting', color: '#A6C74D'},
    {label: 'reports.meetingKind.digital', value: 'Digital meeting', color: '#CD5C5C'},
    {label: 'reports.meetingKind.physical', value: 'Physical meeting', color: '#F08080'},
];